import script from "./PlansComparison.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlansComparison.vue?vue&type=script&setup=true&lang=ts"

import "./PlansComparison.vue?vue&type=style&index=0&id=3bb298db&lang=css"

const __exports__ = script;

export default __exports__